import axios from 'axios';

let endPointApi = window.location.hostname;
//const localhostEndPoint = 'https://d-serprobots.estaleiro.serpro.gov.br/manager/api';
const localhostEndPoint = 'http://localhost:8080/manager/api/';
// const localhostEndPoint = 'https://demo7177110.mockable.io/';

endPointApi = endPointApi !== 'localhost'
  ? `https://${endPointApi}/manager/api`
  : localhostEndPoint;

const endPoint = axios.create({ baseURL: endPointApi });

// Interceptor para error de autorização
endPoint.interceptors.response.use((response) => response, (error) => {
  const errorCode = error.response.status;
  if (errorCode === 403 || errorCode === 401) {
    const { url } = error.config;
    if (url !== '/auth/signin') {
      window.location.href = `${window.location.origin}/curadoria/logout`;
    }
  }
  return Promise.reject(error);
});

// Interceptor para rodar em ambiente de desenvolvmento
if (window.location.hostname === 'localhost') {
  endPoint.interceptors.request.use((_config) => {
    const config = _config;
    const token = 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIwOTE5NDAxNzY3MCIsImlkIjoiYTNiNTViMjYtMWMyYi00ZTU2LTgyOTAtM2FmOTI5OTJmZjlmIiwidXNlcm5hbWUiOiIwOTE5NDAxNzY3MCIsImVtYWlsIjoibHVpcy5icml0b0BzZXJwcm8uZ292LmJyIiwibmFtZSI6Ikx1aXMgSGVucmlxdWUgU2FudG9zIEJyaXRvIiwiYWRtaW4iOnRydWUsImlhdCI6MTY3NTIxMzM4NSwiZXhwIjoxNjc1MjE2OTg1fQ.ZXgy1JLOLMMfWw_BxQgAlbpq3b2D-KXJvqwdKDQuCFSjihJAoWumV5LhAQMymbhFOERU6_wox5As_SJ2BWA20w';
    if (token !== null) config.headers.Authorization = token;
    return config;
  }, (error) => Promise.reject(error));
} else {
  endPoint.interceptors.request.use((_config) => {
    const config = _config;
    const token = localStorage.getItem('token');
    if (token !== null) { config.headers.Authorization = `Bearer ${token}`; }
    return config;
  }, (error) => Promise.reject(error));
}

export default endPoint;
